import { NotificationRule } from '@sp-types/notificationRule';
import { Timestamp } from 'firebase/firestore';
import { DashboardNotification } from '../../../sp-types/notificationType';
import { IHistoryPrice } from '../../../sp-types';

export const genNewNotifRule = (): NotificationRule =>
  ({
    id: '',
    name: '',
    accountId: '',
    materialId: '',
    condition: '',
    created_at: Timestamp.now(),
    enabled: true,
    expireHours: 48,
    type: 'all',
  } as NotificationRule);

export const createNotificationFromRule = (
  rule: NotificationRule,
  accountId: string,
  materialId: string,
  text: string,
  isAlreadySent: boolean,
): DashboardNotification => ({
  id: '',
  type: 'alert',
  accountId,
  materialId: [materialId],
  text,
  descriptionText: '',
  date: Timestamp.now(),
  status: 'started',
  ruleType: rule.type,
  ruleName: rule.name,
  isAlreadySent,
});

export const checkDiffCondition = (diff: number, condition: number, isPercent: boolean, currPrice: number): boolean => {
  return isPercent ? (diff / currPrice) * 100 > condition : diff > condition;
};

export const calcDiff = (prices: IHistoryPrice[], currPrice: number): number => {
  const prevPrice = prices[0].price;
  //const currPrice = prices[prices.length - 1].price;
  return currPrice - prevPrice;
};

export const colDefs = {
  name: true,
  accountId: true,
  materialId: true,
  type: true,
  severity: true,
  condition: true,
  expireHours: true,
  sendEveryDays: { type: 'number' },
  options: { className: 'w-32' },
  enabled: true,
  created_at: true,
  actions: { type: 'actions' },
};

export const notesColDefs = {
  id: '',
  ruleName: true,
  type: 'alert',
  isAlreadySent: { type: 'checkbox' },
  accountId: true,
  materialId: true,
  text: true,
  descriptionText: '',
  date: true,
  status: true,
  ruleType: true,
};

export const getMonthVal = (hp: IHistoryPrice, mon: number): number =>
  (hp as any)?.[`month${mon.toString().padStart(2, '0')}`] || 0;
